var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUncompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3399 -0.000213623H5.66988C2.27988 -0.000213623 -0.00012207 2.37979 -0.00012207 5.91979V14.0898C-0.00012207 17.6198 2.27988 19.9998 5.66988 19.9998H14.3399C17.7299 19.9998 19.9999 17.6198 19.9999 14.0898V5.91979C19.9999 2.37979 17.7299 -0.000213623 14.3399 -0.000213623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3399 -0.000213623H5.66988C2.27988 -0.000213623 -0.00012207 2.37979 -0.00012207 5.91979V14.0898C-0.00012207 17.6198 2.27988 19.9998 5.66988 19.9998H14.3399C17.7299 19.9998 19.9999 17.6198 19.9999 14.0898V5.91979C19.9999 2.37979 17.7299 -0.000213623 14.3399 -0.000213623Z",
    fill: "#EC221F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 11.7703L11.2366 9.99229L13.0146 8.21429C13.3566 7.87329 13.3566 7.31829 13.0146 6.97729C12.6726 6.63329 12.1196 6.63429 11.7776 6.97629L9.99858 8.75429L8.21958 6.97429C7.87758 6.63229 7.32358 6.63429 6.98158 6.97429C6.64058 7.31629 6.64058 7.87129 6.98158 8.21229L8.76158 9.99229L6.98558 11.7673C6.64358 12.1093 6.64358 12.6643 6.98558 13.0043C7.15658 13.1763 7.37958 13.2613 7.60358 13.2613C7.82858 13.2613 8.05158 13.1763 8.22258 13.0053L9.99858 11.2293L11.7786 13.0083C11.9496 13.1793 12.1726 13.2643 12.3966 13.2643C12.6206 13.2643 12.8446 13.1783 13.0156 13.0083C13.3576 12.6663 13.3576 12.1123 13.0156 11.7703Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncompleted);
export default __webpack_public_path__ + "static/media/uncompleted.d76b35d76811fcddcafb86b1163e0d2f.svg";
export { ForwardRef as ReactComponent };